import React from 'react';
import Button from 'antd/lib/button';
import CancelButton from '../../../CancelButton';
import styled from 'styled-components';

const Footer = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
`;

/**
 * Пропсы низа страницы
 */
export type PageFooterProps<T = unknown> = {
  // индикатор процесса отправки
  isSubmitting?: boolean;
  // данные изменились
  dirty?: boolean;
  onCancel?: (values: T) => void | Promise<void>;
  disableSubmitButton?: (values: T) => boolean;
  values?: T;
};

export default function PageFooter<T>(props: PageFooterProps<T>) {
  const submitDisabled =
    props.disableSubmitButton && props.values !== undefined
      ? props.disableSubmitButton(props.values)
      : false;

  return (
    <Footer>
      <Button
        disabled={
          submitDisabled || props.isSubmitting
        }
        loading={props.isSubmitting}
        type="primary"
        htmlType="submit"
        data-cy="save"
      >
        Сохранить
      </Button>
      <CancelButton dirty={!!props.dirty} onClick={props.onCancel}>
        Отменить
      </CancelButton>
    </Footer>
  );
}
